import React from 'react';
import PropTypes from 'prop-types';
import { Icon, List } from '@pella/sash-framework';

import styles from './index.module.scss';

const CalculatorResults = ({ content, calculations, setMeasureStatus }) => {
	if (!calculations) return null;

	return (
		<List
			bullets='none'
			className={`${styles.calculatorResults} mb-8`}
		>
			{calculations.width && (
				<li className='my-1 flex items-center text-base md:text-lg'>
					<Icon
						name='check_circle'
						className={`${styles.calculatorResultsCheck} mr-2`}
					/>
					<span className='font-semibold'>{content?.width_height?.split(', ')?.[0]}:</span>
					<span className='ml-2'>{calculations.width}</span>
				</li>
			)}
			{calculations.height && (
				<li className='my-1 flex items-center text-base md:text-lg'>
					<Icon
						name='check_circle'
						className={`${styles.calculatorResultsCheck} mr-2`}
					/>
					<span className='font-semibold'>{content?.width_height?.split(', ')?.[1]}:</span>
					<span className='ml-2'>{calculations.height}</span>
				</li>
			)}
			<li className='my-4'>
				<button
					className={`${styles.calculatorRecalc} text-sm font-semibold uppercase tracking-wide`}
					onClick={() => setMeasureStatus('calculator')}
				>
					Recalculate Actual Size
				</button>
			</li>
		</List>
	);
};

CalculatorResults.propTypes = {
	content: PropTypes.object,
	calculations: PropTypes.object,
	setMeasureStatus: PropTypes.func,
};

export default CalculatorResults;
